import React from 'react';

import {
  VirtualizedList,
  Actions,
  Action,
  ClearIcon,
} from '@gogame/components';

const PreviewREList = ({ options, onDelete }) => {
  return (
    <VirtualizedList
      data={options}
      secondaryAction={({ id }) => (
        <Actions>
          <Action
            icon={<ClearIcon />}
            label={'Remove'}
            onClick={() => onDelete({ id })}
          />
        </Actions>
      )}
    />
  );
};

export default PreviewREList;
